/* eslint-disable @typescript-eslint/no-explicit-any */
import omit from "lodash.omit";

import { IterUtils } from "../../../Common/IterableUtils";
import { arrayHasAtLeastOneItem } from "../../../Common/TypingUtils";
import { BindingPath } from "../Engine/Core/CoreTypes";

export function getIn(state: any = {}, keys: Iterable<undefined | number | string>, defaultValue?: any): any {
    let value = state;

    for (const key of keys) {
        // @ts-ignore
        if (value[key] === null) {
            return null;
        }

        // @ts-ignore
        if (value[key] === undefined) {
            return defaultValue;
        }

        // @ts-ignore
        value = value[key];
    }

    return value;
}

export function setIn<T>(state: T, keys: ReadonlyArray<number | string>, value: unknown): T {
    const obj = { ...state };
    if (!arrayHasAtLeastOneItem(keys)) {
        return state;
    }
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    const last = keys.slice(0, -1).reduce((part, key) => (part[key] = part[key] ? { ...part[key] } : {}), obj);

    // @ts-ignore
    last[IterUtils.last(keys)] = value;

    return obj;
}

export function updateIn<T>(state: T, keys: readonly string[], fn: (value: any) => any, defaultValue: any): T {
    const obj = { ...state };
    if (!arrayHasAtLeastOneItem(keys)) {
        return state;
    }
    const last = keys
        .slice(0, -1)

        .reduce((part: any, key: string): any => (part[key] = part[key] ? { ...part[key] } : {}), obj);
    const value = last[IterUtils.last(keys)];
    const oldValue = value === undefined ? defaultValue : value;

    last[IterUtils.last(keys)] = fn(oldValue);

    return obj;
}

export function deleteIn<T>(state: T, path: ReadonlyArray<number | string>, key: string): T {
    const newSubstate = omit(getIn(state, path, {}), key);

    return setIn(state, path, newSubstate);
}

export interface ControlBinding {
    path: BindingPath;
    valueName: string;
    propName: string;
}
